// Copyright (c) StrangeBee 2023

import { useFormatDate } from '@Hooks/useFormatDate';
import { ReactElement, memo } from 'react';

interface CommentDateProps {
    date: number;
    prefix?: string;
}

export const CommentDate = memo(({ date, prefix }: CommentDateProps): ReactElement => {
    const f = useFormatDate();

    const dateElement = <time dateTime={f(date)}>{f(date)}</time>;

    return !!prefix ? (
        <i>
            &nbsp;- {prefix} {dateElement}
        </i>
    ) : (
        dateElement
    );
});
